import { useEffect, useState } from "react";
import { apiAuth } from "@/lib/api";

const EVENT_LABEL = {
  startup_submitted: "Startup eingereicht",
  investor_submitted: "Investor:in angemeldet",
  ai_analysis_completed: "AI-Voranalyse abgeschlossen",
  ai_analysis_failed: "AI-Voranalyse fehlgeschlagen",
  pitch_deck_uploaded: "Pitch Deck hochgeladen",
  pitch_deck_downloaded: "Pitch Deck heruntergeladen",
  startup_status_changed: "Startup-Status geändert",
  investor_status_changed: "Investor-Status geändert",
  investor_relationship_updated: "Beziehungsstatus aktualisiert",
  note_created: "Notiz erstellt",
  note_updated: "Notiz bearbeitet",
  note_deleted: "Notiz gelöscht",
  tag_added: "Tag hinzugefügt",
  tag_removed: "Tag entfernt",
  manual_analysis_triggered: "Manuelle Re-Analyse",
  startup_patched: "Startup bearbeitet",
  investor_patched: "Investor:in bearbeitet",
};

export const TimelineList = ({ entityType, entityId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiAuth.get(`/admin/${entityType}s/${entityId}/timeline`).then(({ data }) => {
      if (!cancelled) { setItems(data.items || []); setLoading(false); }
    }).catch(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [entityType, entityId]);

  if (loading) return <p className="text-sm text-warmGrey">Lade …</p>;
  if (items.length === 0) return <p className="text-sm text-warmGrey">Noch keine Aktivitäten.</p>;

  return (
    <ol className="relative border-l-2 border-sandBeige ml-2 pl-6 flex flex-col gap-5" data-testid={`timeline-${entityType}`}>
      {items.map((e) => (
        <li key={e.id} className="relative" data-testid={`timeline-item-${e.id}`}>
          <span className="absolute -left-[33px] top-1 w-3 h-3 rounded-full bg-raspberry border-2 border-white" />
          <p className="text-sm text-cocoa">{EVENT_LABEL[e.event_type] || e.event_type}</p>
          <p className="text-xs text-warmGrey mt-0.5">{new Date(e.timestamp).toLocaleString("de-DE")}</p>
          {e.metadata && Object.keys(e.metadata).length > 0 && (
            <details className="mt-2 text-xs">
              <summary className="text-warmGrey cursor-pointer hover:text-raspberry">Metadata</summary>
              <pre className="mt-2 bg-porcelain rounded-xl p-3 overflow-x-auto whitespace-pre-wrap break-all">
                {JSON.stringify(e.metadata, null, 2)}
              </pre>
            </details>
          )}
        </li>
      ))}
    </ol>
  );
};

export default TimelineList;
